<template>
  <div class="main-container">
    <div style="padding-bottom:24px;">优惠券可用讲师：</div>
    <div class="main clear">
      <div class="teacher f-left" v-if="teachers.length > 0">
        <div class="clear">
          <div
            class="item clear"
            :class="{ current: teacherId == teacher.teacher_id }"
            v-for="teacher in teachers"
            :key="teacher.teacher_id"
            @click="changeTeacher(teacher.teacher_id)"
          >
            <img class="avatar f-left" :src="teacher.avatar" />
            <div class="f-left">
              <div class="title">{{ teacher.real_name }}</div>
              <div class="intro">
                <span>{{ teacher.sex | sex }}</span>
                <span>{{ teacher.age }}岁</span>
                <span>{{ teacher.teach_age }}年教龄</span>
              </div>
              <div class="bottom">
                <router-link :to="{ name: 'OtoTeacherShow', params: { id: teacher.teacher_id } }">
                  详情
                </router-link>
                <a v-if="teacher.is_collect == 0" @click.stop="toggleCollect(teacher)">收藏</a>
                <a v-else @click.stop="toggleCollect(teacher)">取消收藏</a>
              </div>
            </div>
          </div>
        </div>
        <div class="pager clear">
          <a class="left-2" :disabled="page <= 1" @click="goToPage(1)"></a>
          <a class="left" :disabled="page <= 1" @click="goToPage(page - 1)"></a>
          <span>{{ page }}/{{ totalPage }}</span>
          <a class="right" :disabled="page >= totalPage" @click="goToPage(page + 1)"></a>
          <a class="right-2" :disabled="page >= totalPage" @click="goToPage(totalPage)"></a>
        </div>
        <div class="jump">
          <span>跳转至</span>
          <el-input v-model="jumpPage"></el-input>
          <span>页</span>
          <a @click="jump">跳转</a>
        </div>
      </div>
      <div class="teacher empty center f-left" v-else>
        <img src="@/assets/images/oto/empty.png" />
        <div>该时段暂无老师～</div>
      </div>
      <OtoScheduleTable
        :teacherId="teacherId.toString()"
        :is_next="is_next"
        class="f-left"
      ></OtoScheduleTable>
    </div>
  </div>
</template>
<script>
import OtoScheduleTable from "../../components/OtoScheduleTable.vue";

export default {
  name: "Oto",
  components: {
    OtoScheduleTable
  },
  data() {
    return {
      search: {
        teacher_name: "",
        date: "",
        level: 0,
        attr: {},
        is_collect: false,
        is_attended: false,
        beginTime: "",
        endTime: "",
        sex: -1
      },
      levels: [],
      attrs: [],
      showSelectDate: false,
      today: new Date().format("yyyy-MM-dd"),
      thisWeekDates: [],
      nextWeekDates: [],
      teachers: [],
      teacherId: 0,
      timer: 0,
      page: 1,
      limit: 5,
      total: 0,
      totalPage: 0,
      jumpPage: "",
      is_next: 0
    };
  },
  async created() {
    await this.getTeacher();
  },
  methods: {
    async getTeacher() {
      let data = await this.$http.get(
        "/api/app/couponGoods?type=4&coupon_id=" + this.$route.query.id,
        { page: this.page, limit: this.limit }
      );
      this.teachers = data.list;
      this.teacherId = 0;
      if (data.list.length > 0) {
        this.changeTeacher(data.list[0].teacher_id);
      }
      let totalPage = parseInt(data.total / this.limit);
      if (data.total % this.limit > 0) {
        totalPage++;
      }
      this.totalPage = totalPage;
    },
    async changeTeacher(id) {
      this.teacherId = id;
    },
    async toggleCollect(teacher) {
      await this.$http.get("/api/app/teacher/collect/" + teacher.teacher_id, {}, true);
      let is_collect = teacher.is_collect == 0 ? 1 : 0;
      if (is_collect == 1) {
        await this.$success("收藏成功");
      } else {
        await this.$success("取消收藏成功");
      }
      teacher.is_collect = is_collect;
    },
    async goToPage(page) {
      if (page <= 0 || page > this.totalPage || page == this.page) {
        return;
      }
      this.page = page;
      await this.getTeacher();
    },
    async jump() {
      if (!/[0-9]+/.test(this.jumpPage)) {
        this.$info("请输入正整数");
        return;
      }
      if (this.jumpPage > this.totalPage) {
        this.$info("不得大于" + this.totalPage);
        return;
      }
      if (this.jumpPage < 1) {
        this.$info("必须大于0");
        return;
      }
      this.page = this.jumpPage;
      await this.getTeacher();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../css/oto.scss";

.main-container {
  padding-top: 30px;
}
</style>
